import { takeLatest, call, put } from "redux-saga/effects";
import {
  fetchHasPaidRequest,
  fetchHasPaidSuccess,
  fetchHasPaidFailure,
} from "../slices/hasPaidSlice";
import { checkHasPaidAPI } from "../api/hasPaidApi";

function* fetchHasPaidSaga() {
  try {
    const hasPaid = yield call(checkHasPaidAPI);

    yield put(fetchHasPaidSuccess(hasPaid));
  } catch (error) {
    yield put(fetchHasPaidFailure(error.message));
  }
}

export function* watchHasPaidSaga() {
  yield takeLatest(fetchHasPaidRequest.type, fetchHasPaidSaga);
}
